import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useTicketStatus(calendarId: string, eventId: string, userId?: string) {
  const [hasPurchased, setHasPurchased] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    const checkTicketStatus = async () => {
      try {
        const { data, error } = await supabase
          .from('event_tickets')
          .select('status')
          .eq('calendar_id', calendarId)
          .eq('event_id', eventId)
          .eq('user_id', userId)
          .eq('status', 'paid')
          .maybeSingle();

        if (error) throw error;
        setHasPurchased(!!data);
      } catch (err) {
        console.error('Error checking ticket status:', err);
      } finally {
        setLoading(false);
      }
    };

    checkTicketStatus();
  }, [calendarId, eventId, userId]);

  return { hasPurchased, loading };
}